// This file was auto-generated by Fern from our API Definition.
export var ChannelSendResult;
(function (ChannelSendResult) {
    ChannelSendResult.State = {
        Sent: "sent",
        Failed: "failed",
        Unknown: "unknown",
    };
})(ChannelSendResult || (ChannelSendResult = {}));
